import { render, staticRenderFns } from "./AppDownload2.vue?vue&type=template&id=2bbf7b6b&"
import script from "./AppDownload2.vue?vue&type=script&lang=js&"
export * from "./AppDownload2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports